import type { LifeEventPolicy } from '@ben/shared/types/columbia';

export const EMPTY_LIFE_EVENT_CONFIG: LifeEventPolicy = {
  type: [],
  requiresApproval: false,
  requiresProof: true,
  restrictions: [],
};
